export const WALKOVER_NONE = 0;
export const WALKOVER_GUEST_FORFEIT = 1;
export const WALKOVER_HOME_FORFEIT = 2;

const WALKOVER_SET_WIN = '11';
const WALKOVER_SET_LOSS = '0';
const WALKOVER_SETS_WON = 3;

export const normalizeWalkover = (value) => {
    const parsed = Number(value);
    if (parsed === WALKOVER_GUEST_FORFEIT) return WALKOVER_GUEST_FORFEIT;
    if (parsed === WALKOVER_HOME_FORFEIT) return WALKOVER_HOME_FORFEIT;
    return WALKOVER_NONE;
};

export const isWalkover = (value) => normalizeWalkover(value) !== WALKOVER_NONE;

export const buildWalkoverSets = (walkover) => {
    const mode = normalizeWalkover(walkover);
    if (mode === WALKOVER_NONE) return null;

    const homeWins = mode === WALKOVER_GUEST_FORFEIT;
    const sets = [];
    for (let setIndex = 0; setIndex < 5; setIndex += 1) {
        if (setIndex < WALKOVER_SETS_WON) {
            sets.push(homeWins ? WALKOVER_SET_WIN : WALKOVER_SET_LOSS);
            sets.push(homeWins ? WALKOVER_SET_LOSS : WALKOVER_SET_WIN);
        } else {
            sets.push('');
            sets.push('');
        }
    }
    sets.push(homeWins ? WALKOVER_SETS_WON : 0);
    sets.push(homeWins ? 0 : WALKOVER_SETS_WON);
    return sets;
};

export const getWalkoverLabel = (walkover) => {
    const mode = normalizeWalkover(walkover);
    if (mode === WALKOVER_GUEST_FORFEIT) return 'Đội khách bỏ cuộc';
    if (mode === WALKOVER_HOME_FORFEIT) return 'Đội nhà bỏ cuộc';
    return '';
};

export const getWalkoverScoreLabel = (walkover) => {
    const mode = normalizeWalkover(walkover);
    if (mode === WALKOVER_GUEST_FORFEIT) return '3-0';
    if (mode === WALKOVER_HOME_FORFEIT) return '0-3';
    return '';
};
